import { useApiQuery } from "../../../../core/api/useApiQuery"
import { changeUserAccount, ProfileQuery } from "../../profileApi"
import { Box } from "@mui/material"
import { isChangeUserAccountResponse, isUserTypeResponse } from "../helpers/distinguishChangeUserResponse"
import { makeStyles } from "tss-react/mui"
import { UsersList } from "./UsersList"
import { NoAccessContent } from "./NoAccessContent"
import { useEffect, useState } from "react"

const useStyles = makeStyles()(() => ({
    content: {
        minHeight: "20rem",
        height: "100%",
    },
}))

export function ChangeUserAccountContent() {
    const { classes } = useStyles()

    const [isEmailConfirmationSend, setIsEmailConfirmationSend] = useState(false)

    const { data } = useApiQuery(changeUserAccount, {
        queryName: ProfileQuery.CHANGE_USER_ACCOUNT,
        dependencies: {},
        suspense: true,
        useErrorBoundary: true,
        refetchInterval: isEmailConfirmationSend ? 5000 : undefined,
    })

    useEffect(() => {
        if (isUserTypeResponse(data)) {
            setIsEmailConfirmationSend(false)
        }
    }, [data])

    return (
        <Box className={classes.content}>
            {isChangeUserAccountResponse(data) && (
                <NoAccessContent
                    isEmailConfirmationSend={isEmailConfirmationSend}
                    setIsEmailConfirmationSend={setIsEmailConfirmationSend}
                    authenticationResult={data}
                />
            )}

            {isUserTypeResponse(data) && <UsersList user={data.user} users={data.userTypes} />}
        </Box>
    )
}
